import { pay4PopupTab } from "./pay4-popup-tab.js";
import { CartUpdateEvent, ThemeEvents } from '@theme/events';
import { morphSection } from '@theme/section-renderer';

// start of product page: finance options popup - changing the active tab from the popup menu buttons
let pay4Btns = document.querySelectorAll('.pay4_btn');
document.querySelectorAll('.pay4_btn').forEach((button) => button.addEventListener('click', function(e) {
  let clickedBtn = e.target;
  if (clickedBtn instanceof HTMLElement ) {  
    pay4Btns.forEach(btn => { btn.classList.remove("active");});
    clickedBtn.classList.add("active"); 
    let relatedTab = clickedBtn.getAttribute('data-tab');
    document.querySelectorAll(`.pay4_tab`).forEach(tab => { tab.classList.remove("active");});
    document.querySelector(`.pay4_tab${relatedTab}`)?.classList.add("active");
  }
}))
// end of product page: finance options popup - changing the active tab from the popup menu buttons

// start of product page: finance options popup - close button logic
document.querySelector('.pay4_close')?.addEventListener('click', function() {
  document.querySelector('.pay4_overlay')?.classList.remove('active');
})
document.querySelector('.pay4_overlay')?.addEventListener('click', function() {
  document.querySelector('.pay4_overlay')?.classList.remove('active');
})
document.querySelector('.pay4_popup')?.addEventListener('click', function(e) { e.stopPropagation(); });
// end of product page: finance options popup - close button logic

// start of product page: finance options image opens related tab
document.querySelectorAll('.zip4_opener')?.forEach((button) => button.addEventListener('click', function(e) {
  // update all tabs content
  document.querySelectorAll("pay4-popup-tab").forEach(el => {
    if (el instanceof pay4PopupTab) { el.updateTab(); }
    
  });
  // open the related tab  
  let clickedBtn = e.target;
  if (clickedBtn instanceof HTMLElement ) {  
    let relatedTab = clickedBtn.getAttribute('data-tab');
    document.querySelectorAll(`.pay4_btn`).forEach(btn => { btn.classList.remove("active");});
    document.querySelector(`.pay4_btn[data-tab="${relatedTab}"]`)?.classList.add("active");
    document.querySelectorAll(`.pay4_tab`).forEach(tab => { tab.classList.remove("active");});
    document.querySelector(`.pay4_tab${relatedTab}`)?.classList.add("active");
    document.querySelector('.pay4_overlay')?.classList.add('active');
  }
}));
// end of product page: finance options image opens related tab



// Start of product navigation logic
document.addEventListener("DOMContentLoaded", function() {
  // Smooth scrolling
  document.querySelectorAll('.toc-nav a').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      e.preventDefault();
      const target = document.querySelector(this.getAttribute('href'));
      const offset = 100; // px
      const elementPosition = target.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    });
  });

  // Active section highlight
  const sections = document.querySelectorAll(".section");
  const navLinks = document.querySelectorAll(".toc-nav a");
  
  // Function to update active tab
  function updateActiveTab() {
    let current = "";
    sections.forEach((section, i) => {
      if (section instanceof HTMLElement) {
        if (i == sections.length - 1)  return;
        const sectionTop = section.getBoundingClientRect().top  + window.pageYOffset  - 100;
        // @ts-ignore
        const nextSectionTop = sections[i + 1].getBoundingClientRect().top  + window.pageYOffset  - 100;
        if (window.pageYOffset >= sectionTop && window.pageYOffset < nextSectionTop) {
          current = section.getAttribute("id") ?? current;
        } 
      }
    });
    if (current === "") return;
    navLinks.forEach(link => {
      link.classList.remove("active");
      if (link.getAttribute("href") === "#" + current) {
        link.classList.add("active");
      }
    });
  }

  // Add scroll event listener
  window.addEventListener('scroll', updateActiveTab);

});
// end of product navigation logic


// Start of product navigation logic - TOC show and hide the navigation bar
  window.addEventListener("scroll", function () {
    const showTOCafterTheEndOfThisSection = document.querySelector(".product-information");
    const TOC = document.querySelector(".toc-nav");
    const stickyATC = document.querySelector(".product__bot");
    if (showTOCafterTheEndOfThisSection) {
      if (showTOCafterTheEndOfThisSection.getBoundingClientRect().bottom < 0) {
        TOC?.classList.add("show_it");
        stickyATC?.classList.add("show_it");
      } else {
        TOC?.classList.remove("show_it");
        stickyATC?.classList.remove("show_it");
      }
    }  
  });

// end of product navigation logic - TOC show and hide the navigation bar
// start of mattress layer section in mattresses product pages
// When clicking on accordion trigger
document.querySelectorAll(".section-mattress-layers .accordion-trigger").forEach(trigger => {
  trigger.addEventListener("click", function () {
    // Remove expanded from all
    document.querySelectorAll(".section-mattress-layers .accordion-trigger").forEach(tab => {
      tab.classList.remove("expanded");
      if (tab.parentElement ) {
        let expandedContent = tab.parentElement.querySelector(".accordion-content");
        if (expandedContent) { expandedContent.classList.remove("expanded");   }
      }
    });

    // Add expanded to the parent of clicked trigger
    this.classList.add("expanded");
    this.parentElement.querySelector(".accordion-content").classList.add("expanded");

    // Remove active_number from all
    document.querySelectorAll(".section-mattress-layers .L_num").forEach(circle => {
      circle.classList.remove("active_number");
    });

    // Add active_number to the one that matches data attribute
    const numberToBeActive = this.dataset.accordion_specs_number;
    const circleToActivate = document.querySelector(`.section-mattress-layers .circle_number_${numberToBeActive}`);
    if (circleToActivate) {
      circleToActivate.classList.add("active_number");
    }
  });
});

// When clicking on circle image
document.querySelectorAll(".section-mattress-layers .L_num").forEach(circle => {
  circle.addEventListener("click", function () {
    // Get target number
    const numberToBeActive = this.dataset.accordion_specs_number;

    // Find related accordion trigger
    const trigger = document.querySelector(`.section-mattress-layers .spec_link_${numberToBeActive}`);
    if (trigger instanceof HTMLElement && trigger.parentElement instanceof HTMLElement) {
      trigger.click(); // Simulate click on accordion trigger
    }
  });
});

// end of mattress layer section in mattresses product pages


// start of product page: product info icon opens the related popup
document.querySelectorAll('.multiple-tabs').forEach(section => {
  const tabs = section.querySelectorAll('.tab_button');
  const tabsContainer = section.querySelector('.operations__tab-container');
  const tabsContent = section.querySelectorAll('.tab_content');

  if (tabsContainer) {
    tabsContainer.addEventListener('click', function (e) {
      // @ts-ignore
      const clicked = e.target.closest('.tab_button');
      if (!clicked) return;

      // Remove active classes only inside this section
      tabs.forEach(t => t.classList.remove('tab_button--active'));
      tabsContent.forEach(c => c.classList.remove('tab_content--active'));

      // Activate tab
      clicked.classList.add('tab_button--active');

      // Activate related content inside this section
      const targetContent = section.querySelector(
        `.tab_content[data-tab="${clicked.dataset.tab}"]`
      );
      if (targetContent) {
        targetContent.classList.add('tab_content--active');
      }
    });
  }
});

// start of product page: product info icon opens the related popup




// start of product page: product info icon opens the related popup
document.querySelectorAll('.open_popup')?.forEach((button) => button.addEventListener('click', function(e) {
  // @ts-ignore
  let clickedBtn = e.target?.closest(".open_popup");
  if (clickedBtn instanceof HTMLElement ) {
    let relatedTab = clickedBtn.getAttribute('data-tab');
    let targetTab = document.querySelector(`.pi_tab${relatedTab}`);
    let parentOverlay = targetTab?.closest('.pi_overlay');
    if (!targetTab || !parentOverlay) return;
    parentOverlay.querySelectorAll('.pi_btn').forEach(btn => { btn.classList.remove("active"); });
    parentOverlay.querySelector(`.pi_btn[data-tab="${relatedTab}"]`)?.classList.add("active");
    parentOverlay.querySelectorAll('.pi_tab').forEach(tab => { tab.classList.remove("active"); });
    targetTab.classList.add("active");
    parentOverlay.classList.add('active');
  }
}));
// end of product page: product info icon opens the related popup

// start of product page: product info popup - changing the active tab from the popup menu buttons
document.querySelectorAll('.pi_btn').forEach((button) => button.addEventListener('click', function(e) {
  let clickedBtn = e.target;
  if (clickedBtn instanceof HTMLElement ) {
    let parentOverlay = clickedBtn.closest('.pi_overlay');
    if (!parentOverlay) return;
    parentOverlay.querySelectorAll('.pi_btn').forEach(btn => { btn.classList.remove("active"); });
    clickedBtn.classList.add("active");
    let relatedTab = clickedBtn.getAttribute('data-tab');
    let targetTab = parentOverlay.querySelector(`.pi_tab${relatedTab}`);
    parentOverlay.querySelectorAll('.pi_tab').forEach(tab => { tab.classList.remove("active"); });
    targetTab?.classList.add("active");
  }
}))
// end of product page: product info popup - changing the active tab from the popup menu buttons


// start of product page: product info popup - close button logic
document.querySelectorAll('.pi_close').forEach(function(btn) {
  btn.addEventListener('click', function() {
    this.closest('.pi_overlay')?.classList.remove('active');
  });
});
document.querySelectorAll('.pi_overlay').forEach(function(overlay) {
  overlay.addEventListener('click', function() {
    this.classList.remove('active');
  });
});
document.querySelectorAll('.pi_popup').forEach(function(popup) {
  popup.addEventListener('click', function(e) { e.stopPropagation(); });
});
// end of product page: product info popup - close button logic


// start of homepage - comparison table
document
  .getElementById("show_compare_show_more")
  ?.addEventListener("click", function () {
    document.querySelector("#tbody_2")?.classList.add("visible");
    document.getElementById("show_compare_show_more")?.classList.add("hidden");
    document
      .getElementById("show_compare_show_less")
      ?.classList.remove("hidden");
  });

document
  .getElementById("show_compare_show_less")
  ?.addEventListener("click", function () {
    document.querySelector("#tbody_2")?.classList.remove("visible");
    document.getElementById("show_compare_show_less")?.classList.add("hidden");
    document
      .getElementById("show_compare_show_more")
      ?.classList.remove("hidden");
  });

// end of homepage - comparison table

// Start of product navigation logic
document.addEventListener("DOMContentLoaded", function() {
  // Smooth scrolling
  document.querySelectorAll('.toc-page a').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      e.preventDefault();
      const target = document.querySelector(this.getAttribute('href'));
      const offset = 100; // px
      const elementPosition = target.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    });
  });

  // Active section highlight
  const sections = document.querySelectorAll(".group-block");
  const pageLinks = document.querySelectorAll(".toc-page a");
  
  // Function to update active tab
  function updateActiveTab() {
    let current = "";
    sections.forEach((section, i) => {
      if (section instanceof HTMLElement) {
        if (i == sections.length - 1)  return;
        const sectionTop = section.getBoundingClientRect().top  + window.pageYOffset  - 100;
        // @ts-ignore
        const nextSectionTop = sections[i + 1].getBoundingClientRect().top  + window.pageYOffset  - 100;
        if (window.pageYOffset >= sectionTop && window.pageYOffset < nextSectionTop) {
          current = section.getAttribute("id") ?? current;
        } 
      }
    });
    if (current === "") return;
    pageLinks.forEach(link => {
      link.classList.remove("active");
      if (link.getAttribute("href") === "#" + current) {
        link.classList.add("active");
      }
    });
  }

  // Add scroll event listener
  window.addEventListener('scroll', updateActiveTab);

});
// end of product navigation logic

// start of slider settings mobile and tablet for any group block
document.addEventListener("DOMContentLoaded", function() {
    if (window.matchMedia("(max-width: 989.8px)").matches) {
      document.querySelectorAll('.group-slider-mobile').forEach(elem => {
        let flkty = new Flickity( elem, {
          // options
          cellAlign: 'left',
          contain: true,    
          wrapAround: true    
        });
      });
    }
});

// start of product page: cards opener
document.querySelectorAll('.open_card')?.forEach((button) => button.addEventListener('click', function(e) {
  // open the related tab  
  // @ts-ignore
  let clickedBtn = e.target?.closest(".open_card");
  if (clickedBtn instanceof HTMLElement ) {  
    let nextElement = clickedBtn.nextElementSibling;
    
    if (nextElement) {
      nextElement.classList.add("rte");
      let targetP = Array.from(nextElement.querySelectorAll('p > strong')).map(strong => strong.parentElement);    
      targetP.forEach(p => {
        // Apply styles to the p element
        p.style.fontSize = '15px';
        p.style.marginBottom = '10px';
        p.style.letterSpacing = '.3px';
      });
    }
    
    clickedBtn.closest(".group-block-content").classList.add("card_opened");
    clickedBtn.closest(".group-block-content").parentElement.closest(".group-block-content").style.alignItems =  'flex-start';
    clickedBtn.classList.add("hidden");
  }
}));
// end of product page: cards opener


// start of updating the reviews_average, reviews_count on the product page - reviews on the product form 
document.addEventListener("DOMContentLoaded", function () {
  const waitForElement = (selector, callback, interval = 300, timeout = 20000) => {
    const startTime = Date.now();
    const timer = setInterval(() => {
      const el = document.querySelector(selector);
      if (el) {
        clearInterval(timer);
        callback();
      } else if (Date.now() - startTime > timeout) {
        clearInterval(timer);
        console.warn('Element not found within timeout:', selector);
      }
    }, interval);
  };
  waitForElement('#stamped-main-widget .stamped-summary-text', function () {
    // ✅ Your JS code here
      let reviews = document.querySelector('.product-information .review_word');
      if (reviews) {
        let stampedReview = document.querySelector('#stamped-main-widget .stamped-summary-text');
        let stampedAvg = stampedReview.getAttribute('data-rating');
        if (stampedAvg == "5.0") { stampedAvg = "5";}
        let stampedCount = stampedReview.getAttribute('data-count');
        reviews.querySelector(".review_avg").innerHTML = stampedAvg;
        reviews.querySelector(".review_count").innerHTML = stampedCount;
        reviews.classList.remove("hidden-animated");
      }
  });
  
  });
  // end of updating the reviews_average, reviews_count on the product page - reviews on the product form 
  
// Start of check bed warranty exist at the cart 
export async function checkLinkedBedWarrantyAndAddCorrectOne() {
  // change variants ids here from country to another
  /*
  Australia variant ids:
    let longSingleLatexMattressVariantId = 20737535311942;
    let splitKingBedVariantId = 20580498047046;
    let fiveYearWarrantyVariantId = 32080866672705;

  New Zealand variant ids:
    let longSingleLatexMattressVariantId = 34543480602784;
    let splitKingBedVariantId = 34543477817504;
    let fiveYearWarrantyVariantId = 39690003185824;
  */
  let longSingleLatexMattressVariantId = 20737535311942;
  let splitKingBedVariantId = 20580498047046;
  let fiveYearWarrantyVariantId = 32080866672705;
  

  try {
    const response = await fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const cartData = await response.json();
    
    if (cartData.items && cartData.items.length > 0) {
      // Helper function to extract full _linkGroup value from item properties
      function getLinkGroup(item) {
        if (!item.properties) return null;
        
        let linkGroupProp = null;
        if (Array.isArray(item.properties)) {
          linkGroupProp = item.properties.find(prop => prop.name === '_linkGroup');
        } else if (item.properties._linkGroup) {
          linkGroupProp = { value: item.properties._linkGroup };
        }
        
        return linkGroupProp ? linkGroupProp.value : null;
      }

      // Helper function to extract linkedDate from item properties
      function getLinkedDate(item) {
        const linkGroup = getLinkGroup(item);
        if (linkGroup) {
          const parts = linkGroup.split('-');
          if (parts.length >= 2) {
            return parts[1];
          }
        }
        return null;
      }

      // Helper function to get warranty items with matching linkedDate
      function getWarrantiesByLinkedDate(cartItems, linkedDate) {
        return cartItems.filter(item => {
          const handle = item.handle || item.product_handle;
          if (handle !== 'adjustable-bed-warranty') return false;
          
          const warrantyLinkedDate = getLinkedDate(item);
          return warrantyLinkedDate === linkedDate;
        });
      }

      // 1. Get all adjustable-bed items with 'Split King (2 x Long Single)'
      const adjustableBeds = cartData.items.filter(item => {
        const handle = item.handle || item.product_handle;
        return handle === 'adjustable-bed' && item.variant_id === splitKingBedVariantId;
      });

      // 2. Get all latex-mattress items with 'Long Single'
      const latexMattresses = cartData.items.filter(item => {
        const handle = item.handle || item.product_handle;
        return handle === 'latex-mattress' && item.variant_id === longSingleLatexMattressVariantId;
      });

      // 3. Process each bed individually
      for (const adjustableBed of adjustableBeds) {
        const bedQuantity = adjustableBed.quantity;
        const bedLinkedDate = getLinkedDate(adjustableBed);
        
        if (!bedLinkedDate) continue;

        // Find matching mattress with double quantity or larger
        const matchingMattress = latexMattresses.find(mattress => {
          return mattress.quantity >= bedQuantity * 2;
        });

        // Only proceed if matching mattress found
        if (matchingMattress) {
          // 4. Get warranty with matching linkedDate (should be only 1 item)
          const warrantyItems = getWarrantiesByLinkedDate(cartData.items, bedLinkedDate);
          const existingWarranty = warrantyItems.length > 0 ? warrantyItems[0] : null;

          // 5. Check if the existing warranty is the correct one
          const isCorrectWarranty = existingWarranty && 
            existingWarranty.variant_id === fiveYearWarrantyVariantId;

          // If correct warranty doesn't exist, remove wrong warranty and add the correct one
          if (!isCorrectWarranty) {
            // Extract _linkGroup from the existing wrong warranty item before removing, or use bed's linkGroup
            let linkGroupToUse = null;
            if (existingWarranty) {
              linkGroupToUse = getLinkGroup(existingWarranty);
            }

            // Remove existing warranty item if it exists
            if (existingWarranty) {
              try {
                const removeResponse = await fetch('/cart/change.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                  },
                  body: JSON.stringify({
                    id: existingWarranty.key,
                    quantity: 0
                  })
                });

                if (removeResponse.ok) {
                  const removeData = await removeResponse.json();
                  if (!removeData.error) {
                    console.log(`Removed warranty item: ${existingWarranty.variant_title} (linkedDate: ${bedLinkedDate})`);
                  }
                }
              } catch (error) {
                console.error('Error removing warranty item:', error);
              }
            }

            // Add the correct warranty with quantity matching bed quantity and _linkGroup from wrong warranty
            try {
              const addFormData = new FormData();
              addFormData.append('id', '32080866672705');
              addFormData.append('quantity', bedQuantity.toString());
              if (linkGroupToUse) {
                addFormData.append('properties[_linkGroup]', linkGroupToUse);
              }

              const addResponse = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                  'Accept': 'application/json'
                },
                body: addFormData
              });

              const addData = await addResponse.json();
              if (addData.error) {
                console.error('Error adding warranty:', addData.message || addData.description);
              } else {
                // Update bed's _linkGroup property before section updates
                let newBedlinkGroup = fiveYearWarrantyVariantId.toString() + "-" + bedLinkedDate;
                
                try {
                  const updateBedResponse = await fetch('/cart/change.js', {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json',
                      'Accept': 'application/json'
                    },
                    body: JSON.stringify({
                      id: adjustableBed.key,
                      properties: {
                        _linkGroup: newBedlinkGroup
                      }
                    })
                  });

                  if (updateBedResponse.ok) {
                    const updateBedData = await updateBedResponse.json();
                    if (updateBedData.error) {
                      console.error('Error updating bed _linkGroup:', updateBedData.message || updateBedData.description);
                    } else {
                      console.log(`Updated bed _linkGroup to: ${newBedlinkGroup}`);
                    }
                  }
                } catch (error) {
                  console.error('Error updating bed _linkGroup:', error);
                }

                // Fetch updated cart to get latest item count
                const updatedCartResponse = await fetch('/cart.js', {
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                  }
                });

                if (updatedCartResponse.ok) {
                  const updatedCartData = await updatedCartResponse.json();
                  
                  // Dispatch cart update event to update cart icon count
                  document.dispatchEvent(
                    new CartUpdateEvent(updatedCartData, 'warranty-update', {
                      itemCount: updatedCartData.item_count || 0,
                      source: 'warranty-update'
                    })
                  );

                  // Update cart sections if they exist on the page
                  const cartItemsComponents = document.querySelectorAll('cart-items-component[data-section-id]');
                  if (cartItemsComponents.length > 0) {
                    // Get section IDs from cart components
                    const sectionIds = Array.from(cartItemsComponents).map(comp => comp.dataset.sectionId).filter(Boolean);
                    
                    if (sectionIds.length > 0) {
                      // Request sections update using Shopify Sections API
                      const sectionsParam = sectionIds.join(',');
                      const sectionsUrl = `${window.location.pathname}?sections=${sectionsParam}`;
                      
                      fetch(sectionsUrl, {
                        method: 'GET',
                        headers: {
                          'Accept': 'application/json'
                        }
                      })
                        .then(response => response.json())
                        .then(sections => {
                          sectionIds.forEach(sectionId => {
                            if (sections[sectionId]) {
                              morphSection(sectionId, sections[sectionId]);
                            }
                          });
                        })
                        .catch(error => {
                          console.error('Error updating cart sections:', error);
                        });
                    }
                  }
                }
              }
            } catch (error) {
              console.error('Error adding warranty:', error);
            }
            
          }
        }
      }
    } 
  } catch (error) {
    console.error('Error fetching cart data:', error);
  }
}
// end of check bed warranty exist at the cart 





